import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuSelect } from "../../components/neu/Neu";
import { Field } from "../../components/neu/Field";
import { createAccount, updateAccount } from "../../api/accounting";

const TYPES = ["asset", "liability", "equity", "revenue", "expense"];
const EMPTY = { code: "", name: "", name_ar: "", type: "asset", parent_code: "", is_leaf: true };

// إضافة حساب جديد أو تعديل حساب قائم في شجرة الحسابات.
export const AccountForm = ({ initial, onDone, onCancel }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ ...EMPTY, ...(initial || {}) });
  const [busy, setBusy] = useState(false);
  const editing = Boolean(initial?.code);

  const save = async () => {
    setBusy(true);
    try {
      if (editing) await updateAccount(initial.code, { name: form.name, name_ar: form.name_ar || null });
      else await createAccount({ ...form, parent_code: form.parent_code || null });
      toast.success(t("acct.accountSaved"));
      onDone();
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard className="animate-rise-in" data-testid="account-form">
      <p className="label-xs">{editing ? t("acct.editAccount") : t("acct.addAccount")}</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        <Field label={t("acct.code")} testId="account-code" value={form.code} disabled={editing}
          onChange={(v) => setForm({ ...form, code: v })} />
        <div>
          <p className="label-xs mb-2">{t("acct.accountType")}</p>
          <NeuSelect data-testid="account-type" value={form.type} disabled={editing}
            onChange={(e) => setForm({ ...form, type: e.target.value })}>
            {TYPES.map((x) => <option key={x} value={x}>{t(`acct.types.${x}`)}</option>)}
          </NeuSelect>
        </div>
        <Field label={t("acct.nameEn")} testId="account-name" value={form.name}
          onChange={(v) => setForm({ ...form, name: v })} />
        <Field label={t("acct.nameAr")} testId="account-name-ar" value={form.name_ar ?? ""}
          onChange={(v) => setForm({ ...form, name_ar: v })} />
        {editing ? null : (
          <Field label={t("acct.parentCode")} testId="account-parent" value={form.parent_code}
            onChange={(v) => setForm({ ...form, parent_code: v })} />
        )}
      </div>
      <div className="mt-5 flex gap-2">
        <NeuButton variant="primary" data-testid="account-save" disabled={busy} onClick={save}>
          {t("app.save")}
        </NeuButton>
        <NeuButton data-testid="account-cancel" onClick={onCancel}>{t("app.cancel")}</NeuButton>
      </div>
    </NeuCard>
  );
};
